import { hc } from "hono/client";
import type { AppType } from "../../worker/app";
import { AuditQuerySchema, AuditResponseSchema, type AuditQuery } from "../../shared/audit-schemas";
import { parseResponse } from "./client-core";

const rpc = hc<AppType>("/", { init: { credentials: "same-origin" } });

function queryParameters(input: AuditQuery): Record<string, string> {
  return Object.fromEntries(
    Object.entries(AuditQuerySchema.parse(input))
      .filter(([, value]) => value !== undefined)
      .map(([key, value]) => [key, String(value)]),
  );
}

export async function listOperationsAudit(input: AuditQuery, signal?: AbortSignal) {
  const query = new URLSearchParams(queryParameters(input));
  return parseResponse(
    await fetch(`/api/ops/audit-events?${query}`, {
      credentials: "same-origin",
      signal: signal ?? null,
    }),
    AuditResponseSchema,
  );
}

export async function listWorkspaceAudit(
  organizationId: string,
  input: AuditQuery,
  signal?: AbortSignal,
) {
  const response = await rpc.api.workspaces[":organizationId"]["audit-events"].$get(
    {
      param: { organizationId },
      query: { ...AuditQuerySchema.parse(input), pageSize: String(input.pageSize) },
    },
    { init: { signal: signal ?? null } },
  );
  return parseResponse(response, AuditResponseSchema);
}
